import React from 'react';
import { logSessionInfo } from '../../../services/logger';

export default class PictureStoryPage extends React.Component {
  constructor(props) {
    super(props);
    this.handleImageError = this.handleImageError.bind(this);
  }

  handleImageError() {
    console.warn("Unable to load image in picture story page", typeof this.props.phrase === 'string' ? this.props.phrase : 'TOO_BIG_TO_LOG', this.props.imageURL);
    logSessionInfo('unable_to_load_image_in_picture_story_page', { phrase: typeof this.props.phrase === 'string' ? this.props.phrase : 'TOO_BIG_TO_LOG', imageURL: this.props.imageURL });
  }

  render() {
    let {imageURL} = this.props;
    if(imageURL && process.env.ASSET_ROOT){
      imageURL = imageURL.replace("s3.amazonaws.com/amira-assets",process.env.ASSET_ROOT);
    }

    let imageProvided = !!imageURL && imageURL !== '';

    return (
      <div className="pictureStoryPage">
        {imageProvided && <img className="pageImage" src={imageURL} alt="" onError={this.handleImageError} />}
        <div className="pagePhrase">{this.props.phrase}</div>
      </div>
    );
  }
}
